import smoothscroll from 'smoothscroll-polyfill';
(window as any).__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();